/* eslint-disable no-nested-ternary */
import * as React from 'react';
import { Popover } from 'antd-mobile';
import { Utils } from '@/utils/app';

import './index.less';

const icons = 'https://diy-assets.msstatic.com/game-release/tips.svg';

const { jumpGameDetail, handleClickGiftRep,} = Utils;

function GameWelfare(props: any) {
  const { prizeData = [], innerTrue, gameBaseInfo, fromId, handTipsImgVis} = props;
  const { postStatus } = gameBaseInfo;
  //  // 礼包,1;2,激活码;3,预约专属礼包;4,下载礼包;5,代金券
  // 1,已结束;2,已领光;3,已领取;4,未开始;5,可领取

  const textObj: any = {
    1: '已结束',
    2: '已领光',
    3: '已领取',
    4: '未开始',
    5: '预约立即领取',
    6: '下载立即领取',
    7: '预约后游戏内领取',
    8: '下载后游戏内领取',
  };

  const getText = (taskStatus: any) => {
    switch (taskStatus) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 3:
        return 3;
      case 5:
        if (postStatus == 1) {
          if (innerTrue) {
            return 8;
          } else {
            return 6;
          }
        } else if (postStatus == 2) {
          if (innerTrue) {
            return 7;
          } else {
            return 5;
          }
        }
        return 5;
      default:
        return 4;
    }
  };

  const getPrinkRep = () => {
    if (innerTrue) return 'game';
    if (postStatus == 1) return 'havedownload';
    if (postStatus == 2) return 'order';
    return 'common';
  };

  const getRep = (obj: any) => {
    const newObj = {
      gamename: gameBaseInfo?.gameName,
      gameid: gameBaseInfo?.gameId,
      area: obj?.area,
      type: getPrinkRep(),
      gifttitle: obj?.title,
      position: obj?.index,
      button_status: postStatus == 1 ? 'download' : postStatus == 2 ? 'order' : '',
    };
    handleClickGiftRep(newObj);
    if (obj.area == 'getbutton') {
      jumpGameDetail({ gameId: gameBaseInfo?.gameId, fromId}, handTipsImgVis);
    }
  };

  const getKey = () => {
    if (postStatus == 1) {
      return 8;
    }
    if (postStatus == 2) {
      return 7;
    }
    return 0;
  };

  return (
    <div className='c-a-i-wrapper'>
      {(prizeData || []).map((item: any, i: number) => (
        <div className={`comment-award-wrapper ${innerTrue ? 'inner-true' : 'inner-false'}`} key={item.welfareId || item.id}>
          <div className='a-w-title'>
            <span className='a-w-title-l'>{item.welfareName}</span>
            <span className='a-w-title-r'>
              {innerTrue ? '游戏内可领取' : '如何使用'}
              {innerTrue ? null : (
                <Popover content={item.welfareUsage} trigger='click' placement='left-start'>
                  <img src={icons} alt='' />
                </Popover>
              )}
            </span>
          </div>
          <div className='a-w-middle-box'>
            <div className='a-w-middle'>
              {(item.contents?.value || item.items?.value || []).map((ele: any, i: number) => (
                <div className='a-w-m-wrapper' key={`p_${i}`}>
                  <div className='m-w-box'>
                    <img src={ele.contentImg || ele.pic} alt='图片' />
                  </div>
                  <div className='m-w-text'>{ele.contentName || ele.desc}</div>
                </div>
              ))}
            </div>
          </div>
          <div className={`a-w-btn status${innerTrue ? getKey() : getText(item.userIfCanPick)}`} onClick={() => getRep({ title: item.welfareName, index: i + 1, area: 'getbutton' })}>
            {textObj[innerTrue ? getKey() : getText(item.userIfCanPick)]}
            {item.userIfCanPick == 5 && item.welfareUsedCount ? (
              <span className='btn-receive-status'>
                {'('}
                {item.welfareUsedCount}人已领取{')'}
              </span>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}

export default GameWelfare;
